import useJwt from '@/auth/jwt/useJwt'
import secureLocalStorage from '@/libs/secureLocalstorage'
import Cookies from 'js-cookie'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && secureLocalStorage.get(useJwt.jwtConfig.storageTokenKeyName)
}

/**
 * Parse and return user data stored in localStorage.
 * @returns {Object|null}
 */
export const getUserData = () => {
  try {
    return JSON.parse(localStorage.getItem('userData'))
  } catch {
    return null
  }
}

/**
 * Role ID constants mapped to backend role_id values.
 */
export const ROLE_IDS = Object.freeze({
  ADMIN: 1,
})

/**
 * Check whether the current user's role_id is included in allowedRoles.
 * Returns true if allowedRoles is omitted or empty (unrestricted).
 *
 * @param {number[]} [allowedRoles] - Whitelisted role IDs
 * @param {Object|null} [userData] - User profile object (falls back to localStorage)
 * @returns {boolean}
 */
export const hasRoleAccess = (allowedRoles, userData = getUserData()) => {
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) return true
  const resolvedUser = userData && Object.keys(userData).length > 0 ? userData : getUserData()
  const userRoleId = Number(resolvedUser?.role_id)
  if (!Number.isInteger(userRoleId) || userRoleId <= 0) return false
  return allowedRoles.includes(userRoleId)
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'ADMIN') return '/'
  if (userRole === 'MANAGEMENT') return '/'
  return { name: 'auth-login' }
}
